import { ThemeProvider, css } from "@emotion/react";
import styled from "@emotion/styled";
import { FC } from "react";
import { Link } from "react-router-dom";

import { DesignToken } from "@livechat/design-system-react-components";

import { Grid, ViewContainer, ViewStack } from "components/grid";
import { SideNavigation } from "components/side-navigation";
import { ISideNavigationItem } from "interfaces/sideNavigationItem";
import { withVar } from "themes/helpers";
import { legacyTheme } from "themes/legacyTheme";

import Upgrade from "./Upgrade";
import { textNormal, textPrimary } from "./styled/typography";

const StyledGrid = styled(Grid)`
  font-family: "Source Sans Pro", sans-serif;
`;

const ViewContainerClass = css`
  overflow: auto;
`;

const disableNavigationStyles = css`
  position: relative;
  opacity: 0.3;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
`;

const navigationUpgradeLinkStyles = [
  textNormal,
  textPrimary,
  css`
    margin: 14px 20px 0 20px;
    border-top: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
    padding: 12px 0;
    text-align: center;
  `,
];

interface IProps {
  title: string;
  subtitle?: string;
  route: string;
  items: ISideNavigationItem[];
  showBackButton: boolean;
  backButton?: React.ReactElement;
  hasAccess: boolean;
  onActiveItemUpdated(item: ISideNavigationItem, customItemTitle: string): void;
  children: React.ReactNode;
}

const ReportsGrid: FC<IProps> = props => {
  const { title, subtitle, backButton, showBackButton, route, items, onActiveItemUpdated, children, hasAccess } = props;

  const navigation = (
    <SideNavigation
      activeItemId={hasAccess ? route : "last-7-days"}
      items={items}
      onActiveItemUpdated={onActiveItemUpdated}
    />
  );

  return (
    <StyledGrid relativeWidths={[1, 10]} minWidths={[280, 0]}>
      <ViewStack>
        <ThemeProvider theme={legacyTheme}>
          <ViewContainer title="Reports">
            {hasAccess ? (
              navigation
            ) : (
              <div>
                <div css={disableNavigationStyles}>{navigation}</div>
                <div css={navigationUpgradeLinkStyles}>
                  <Link to="/subscription">Upgrade your plan</Link> to access Reports.
                </div>
              </div>
            )}
          </ViewContainer>
        </ThemeProvider>
      </ViewStack>
      <ViewStack>
        <ThemeProvider theme={legacyTheme}>
          <ViewContainer
            stackShowBackButton={showBackButton}
            backButton={backButton}
            title={hasAccess ? title : "Get access to Reports"}
            subtitle={subtitle}
            contentCss={ViewContainerClass}
            placement="main-content"
          >
            {hasAccess ? children : <Upgrade />}
          </ViewContainer>
        </ThemeProvider>
      </ViewStack>
    </StyledGrid>
  );
};

export default ReportsGrid;
